const Permissions = (permission) => {
  return {
    isEditor: permission.includes(8),
    isEliminator: permission.includes(9),
    isCreator: permission.includes(10),
    canSeeAdmin: permission.includes(7),
  };
};

export default Permissions;
